import 'assets/scss/components/maincontentheader.scss';
import BackButton from './Header/BackButton.js';
import Logo from './Header/Logo.js';
//import ListGridToggle from './Header/ListGridToggle.jsx';
import ExpertButton from './Header/ExpertButton.js';

export default function MainContentHeader({ isExpress, isExpertMode, forceEasyMode, handleExpertModeToggle, showExpertModeModal, handleExpertModeModalToggle, settings, set, handleGridListViewToggle, gridListToggle })
{
    return (
        <div className="header-container border-bottom py-2">
            <div className="header-inner-container d-flex justify-content-between align-items-center mx-auto">
                <div className="left-container ms-3">
                    <BackButton set={set} />
                </div>
                <div className="px-2">
                    <Logo settings={settings} />
                </div>
                <div className="right-container me-3">
                    <span className="d-flex align-items-center">

                        {/*<ListGridToggle handleGridListViewToggle={handleGridListViewToggle} gridListToggle={gridListToggle}/>*/}
                        {isExpress ? null : <ExpertButton isExpertMode={isExpertMode} forceEasyMode={forceEasyMode} handleExpertModeToggle={handleExpertModeToggle} showExpertModeModal={showExpertModeModal} handleExpertModeModalToggle={handleExpertModeModalToggle} settings={settings} />}
                    </span>
                </div>
            </div>
        </div>
    );
}